import { ReactElement } from "react";
import { isObject } from "../record/isObject";
import { doKeysExist } from "../record/doKeysExist";

export const isReactElement = (value: any): value is ReactElement =>
    isObject(value) 
    && doKeysExist(["key", "props", "type"])(value)
;